<template>
    <div class="lang arabic">
        <div class="info">
            <h3 class="bullet01">معلومات لحاملي التأمين الصحي الوطني (NHIS)</h3>
            <p class="depth">
                يجب على المرضى الذين يتمتعون بالتأمين الصحي الوطني الكوري (NHIS) إحضار خطاب إحالة من
                طبيب محلي وإرساله إلى مكتب التسجيل للحصول على مزايا التأمين. خلاف ذلك، سوف تحتاج إلى
                مقابلة مع طبيب في قسم طب الأسرة أولاً.
                <br>
                خطاب الإحالة ينطبق فقط على القسم المتعلق بالرأي الطبي المذكور في خطاب الإحالة، وإذا كنت
                ترغب في الحصول على علاج من قسم آخر، يجب عليك إحضار خطاب الإحالة مع الرأي الطبي
                للقسم المختص.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">معلومات لحاملي التأمين الصحي الخاص</h3>
            <p class="depth">
                سيُطلب من المرضى الذين لديهم التأمين الصحي الخاص أن يدفعوا مقدمًا، ثم يقدمون مطالبة إلى
                شركة التأمين الخاصة بك لاسترداد التكاليف.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>